export default __webpack_public_path__ + "static/yaxis-73c44f30c2bf4ddccf8de1c8d38ea96d.jpg";